const sensitiveKeywords = ['password', 'token', 'secret', 'code', 'name', 'surname', 'email', 'mobile_refresh_token'];

export class SensitiveDataSanitizer {
  public sanitizeUrl(url: string): string {
    return sensitiveKeywords.reduce(
      (currentUrl, keyword) => currentUrl.replace(RegExp(`${keyword}=[^&]*`, 'g'), `${keyword}=sanitized`),
      url,
    );
  }

  public sanitizeRequest(request: any): any {
    if (request.headers.Authorization) {
      request.headers.Authorization = 'sanitized';
    }

    request.body = this.sanitizeSensitiveData(request.body);

    return request;
  }

  public sanitizeResponse(response: any): any {
    response.body = this.sanitizeSensitiveData(response.body);

    if (response.status === 0) {
      response.status = 200;
    }

    return response;
  }

  private sanitizeSensitiveData(body: any): any {
    if (typeof body === 'string' && this.includesSensitiveKeyword(body)) {
      try {
        const object = JSON.parse(body);
        if (this.shouldSanitize(object)) {
          return 'sanitized';
        }
      } catch (e) {
        return 'error during sanitizing' + e;
      }
    } else {
      return body;
    }
  }

  private shouldSanitize(body: object): any {
    const keys = Object.keys(body);
    const values = Object.values(body);
    return (
      !!keys.find((key) => this.includesSensitiveKeyword(key.toLocaleLowerCase())) ||
      !!values.find((value) => typeof value === 'object' && this.shouldSanitize(value))
    );
  }

  private includesSensitiveKeyword(text: string): boolean {
    const lowercase = text.toLocaleLowerCase();
    return !!sensitiveKeywords.find((keyword) => lowercase.includes(keyword));
  }
}
